export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "org_invoices_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_number_containers_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores pagados"])},
          "total_number_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas pagadas"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
          "num_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Facturas"])},
          "org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagadas"])},
          "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagado"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to processes list"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "org_invoices_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoices"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "total_number_containers_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid containers"])},
          "total_number_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoices"])},
          "total_number_org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid invoices"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total amount"])},
          "num_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Invoices"])},
          "org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid"])},
          "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download report"])}
        }
      }
    }
  })
}